import React from 'react';

function Landing({ onStart }) {
  return (
    <div style={{ background: '#0F172A', color: '#F8FAFC', minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', lineHeight: 1.6 }}>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '80px 20px', textAlign: 'center' }}>
        <img src="/logo2.png" alt="Khepri" style={{ width: 120, height: 120, marginBottom: 16, objectFit: 'contain' }} />
        <h1 style={{ fontSize: 48, fontWeight: 700, marginBottom: 12, color: '#F7DE8A' }}>Khepri</h1>
        <p style={{ fontSize: 20, color: '#F7DE8A', marginBottom: 24, fontWeight: 600 }}>ИИ-операционная система для малого бизнеса</p>
        <p style={{ fontSize: 18, color: '#94A3B8', marginBottom: 40, maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}>
          Одно окно для баланса, налогов, контрагентов и договоров. Khepri предсказывает кассовые разрывы, находит налоговые льготы и каждое утро даёт 3 ключевые задачи.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 40 }}>
          <div style={{ background: '#1E293B', padding: '24px 16px', borderRadius: 12, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>💰</div>
            <div style={{ fontWeight: 600, marginBottom: 4, color: '#F7DE8A' }}>Кассовый прогноз</div>
            <div style={{ fontSize: 13, color: '#94A3B8' }}>Прогноз на 14 дней с зонами риска</div>
          </div>
          <div style={{ background: '#1E293B', padding: '24px 16px', borderRadius: 12, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📅</div>
            <div style={{ fontWeight: 600, marginBottom: 4, color: '#F7DE8A' }}>Налоговый календарь</div>
            <div style={{ fontSize: 13, color: '#94A3B8' }}>Никогда не пропустите дату платежа</div>
          </div>
          <div style={{ background: '#1E293B', padding: '24px 16px', borderRadius: 12, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🔍</div>
            <div style={{ fontWeight: 600, marginBottom: 4, color: '#F7DE8A' }}>Контрагенты</div>
            <div style={{ fontSize: 13, color: '#94A3B8' }}>Проверка рисков по ИНН за секунды</div>
          </div>
          <div style={{ background: '#1E293B', padding: '24px 16px', borderRadius: 12, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📝</div>
            <div style={{ fontWeight: 600, marginBottom: 4, color: '#F7DE8A' }}>Договоры</div>
            <div style={{ fontSize: 13, color: '#94A3B8' }}>Генерация ИИ в один клик</div>
          </div>
          <div style={{ background: '#1E293B', padding: '24px 16px', borderRadius: 12, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🔔</div>
            <div style={{ fontWeight: 600, marginBottom: 4, color: '#F7DE8A' }}>Уведомления</div>
            <div style={{ fontSize: 13, color: '#94A3B8' }}>Оповещения о налогах и рисках в реальном времени</div>
          </div>
          <div style={{ background: '#1E293B', padding: '24px 16px', borderRadius: 12, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🤖</div>
            <div style={{ fontWeight: 600, marginBottom: 4, color: '#F7DE8A' }}>ИИ-помощник</div>
            <div style={{ fontSize: 13, color: '#94A3B8' }}>Рекомендации на базе GigaChat</div>
          </div>
        </div>

        <button onClick={onStart} style={{ padding: '16px 48px', background: '#F7DE8A', color: '#0F172A', borderRadius: 12, border: 'none', fontWeight: 700, fontSize: 18, cursor: 'pointer' }}>
          Попробовать демо
        </button>
        <p style={{ marginTop: 16, fontSize: 14, color: '#94A3B8' }}>demo@khepri.ru / demo123</p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginTop: 60, paddingTop: 40, borderTop: '1px solid #8A6636' }}>
          <div><div style={{ fontSize: 32, fontWeight: 700, color: '#F7DE8A' }}>91 млрд ₽</div><div style={{ fontSize: 13, color: '#94A3B8' }}>Рынок SaaS (Россия)</div></div>
          <div><div style={{ fontSize: 32, fontWeight: 700, color: '#F7DE8A' }}>2,6 млн</div><div style={{ fontSize: 13, color: '#94A3B8' }}>МСП в России</div></div>
          <div><div style={{ fontSize: 32, fontWeight: 700, color: '#F7DE8A' }}>13,9:1</div><div style={{ fontSize: 13, color: '#94A3B8' }}>Коэффициент LTV/CAC</div></div>
        </div>

        <div style={{ marginTop: 40, display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap' }}>
          <a href="/privacy" style={{ color: '#94A3B8', fontSize: 12, textDecoration: 'underline' }}>Политика ПДн</a>
          <a href="/offer" style={{ color: '#94A3B8', fontSize: 12, textDecoration: 'underline' }}>Оферта</a>
        </div>
      </div>
    </div>
  );
}

export default Landing;